/**
 * @param {'hero module' | 'homepage module'} clickType
 * @param {string} collectionType the linked handle
 * @param {'button' | 'image'} buttonType
 */
export default function trackHomepageClick (clickType, collectionType, buttonType) {
    var event = {
        event: 'homepage-click',
        clickType: clickType,
        collectionType: collectionType,
        buttonType: buttonType,
    };

    window.dataLayer.push(event);
}